import React from 'react'
import Loading from "../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const MobileAPOS = dynamic(() => import('../components/aPOS/MobileAPOS'), {
    loading: () => <Loading />,

});
const DesktopAPOS = dynamic(() => import('../components/aPOS/DesktopAPOS'), {
    loading: () => <Loading />,

});

const androidPosBilling = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>
                    Android POS Billing App for Small to Large Format Retail Outlets
                </title>
                <meta
                    name="description"
                    content="QueueBuster's Android POS Billing App is designed for small to large format retail outlets, offering seamless billing, inventory, khata, eStore, CRM and loyalty   "
                />
                <link rel="canonical" href="https://queuebuster.co/android-pos-billing" />
                <link rel="alternate" href="https://queuebuster.co/android-pos-billing" hrefLang="en-us" />
                <meta
                    property="og:title"
                    content="Best Android Billing Software App | Top POS Solutions App India"
                />
                <meta
                    property="og:description"
                    content="Find the best Android billing software for your business. Explore top POS solutions and efficient Android billing systems. Check out the features or take a trial today!"
                />
                <meta property="og:url" content="https://queuebuster.co/android-pos-billing" />
                <meta
                    property="og:image"
                    content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/android.jpg"
                />
            </Head>
            {
                mobileView ? <MobileAPOS /> : <DesktopAPOS />
            }
        </>
    )
}

export default androidPosBilling